































































import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/mixins/pagination'
import { TableColumnItemType, OperationItemType } from '@/types/type'
import { CanteenModule, UserModule, CommonModule } from '@/store'
import { findItemForTree } from '@/utils/toolsForCommon'
import DateUtil from '@/utils/toolsForDate'
@Component({
  name: 'InventoryOverview',
  mixins: [Pagination],
  components: {
    'table-module': () => import('@/components/common/tableModule.vue')
  }
})
export default class InventoryOverview extends Vue {
  public loading = false
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '科目编号',
      key: 'subject',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '科目名称',
      key: 'subjectName',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '库存',
      key: 'amount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '出库',
      key: 'stockRemoval',
      type: 'warning',
      size: 'mini'
    }
  ]
  public timerIdGetServerTime = 0
  public timerIdUpdateCurrentTime = 0
  public currentTime: number = new Date().getTime()

  public orgIdChecked: string | Array<string> = ''
  public schoolName = ''
  public subjectsCount = 0

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get today () {
    return DateUtil.getNowDay()
  }

  get weekDay () {
    return (DateUtil.getWeek(this.today) || '').replace('周', '星期')
  }

  get timeResult () {
    return DateUtil.getTimeForDate(this.currentTime).split(' ')[1]
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  async mounted () {
    this.updateCurrentTimeFromServer()
    this.updateCurrentTimeSecond()
    this.$once('hook:beforeDestroy', () => {
      this.timerIdGetServerTime && clearInterval(this.timerIdGetServerTime)
      this.timerIdUpdateCurrentTime && clearInterval(this.timerIdUpdateCurrentTime)
    })
    await Promise.all([
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.getInventoryStock()
  }

  getServerTime () {
    return new Promise(async resolve => {
      try {
        const { data: result } = await (this as any).$http.constantCurrentTime()
        if (result.code !== 200) return resolve(new Date().getTime())
        const time = result.rt ? new Date((result.rt).replace(/-/g, '/')).getTime() : new Date().getTime()
        resolve(time)
      } catch (err) {
        console.log(err)
      }
    })
  }

  async updateCurrentTimeFromServer () {
    this.currentTime = await this.getServerTime() as number
    const step = 60 * 1000
    this.timerIdGetServerTime = setInterval(async () => {
      this.currentTime = await this.getServerTime() as number
    }, step)
  }

  updateCurrentTimeSecond () {
    this.timerIdUpdateCurrentTime = setInterval(() => {
      this.currentTime += 1000
    }, 1000)
  }

  async getInventoryStock () {
    try {
      this.loading = true
      const params = {
        // orgId: this.userInfo.organizationId
        // orgId: 27
      }
      if (this.orgIdChecked) {
        if (this.orgIdChecked.length) {
          Object.assign(params, {
            orgId: this.orgIdChecked[this.orgIdChecked.length - 1]
          })
        }
      }
      if (!Object.keys(params).length) {
        this.loading = false
        return
      }
      const { data: result } = await (this as any).$http.inventoryStock(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error('抱歉，库存总览查询失败，请联系管理员')
      ;(this as any).tableDataList = (result.data || []).map(item => {
        return item
      })
      this.subjectsCount = (this as any).tableDataList.length
    } catch (err) {
      console.log(err)
    }
  }

  cascaderChooseChangeForTreeDataForSubOrganatizion (value) {
    const orgId = this.orgIdChecked[this.orgIdChecked.length - 1]
    const orgItem = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', orgId) as { name: string }
    if (Object.keys(orgItem).length) {
      this.schoolName = orgItem.name
    }
    this.getInventoryStock()
  }

  canteenInventoryAddOrUpdate (id: string, inOrOut: number, subject?: string) {
    const query = {
      id,
      inOrOut: String(inOrOut)
    }
    const orgId = this.orgIdChecked[this.orgIdChecked.length - 1]
    if (orgId) {
      Object.assign(query, {
        orgId
      })
    }
    if (subject) {
      Object.assign(query, {
        subject
      })
    }
    this.$router.push({
      name: 'AddOrUpdateCanteenInventory',
      query
    })
  }

  operationForButton ({ key }, row) {
    switch (key) {
      case 'stockRemoval':
        this.canteenInventoryAddOrUpdate('add', 1, row.subject)
        break
    }
  }
}
